module.exports = __webpack_public_path__ + "static/images/e76d6281ef601b7648845f999e8bed0c.png";